import { getConfig } from "../lib/configMgr";
import { RequestBuilder, toJSON } from "./request";

const { ExternalRESTAPI } = getConfig();

export const deleteMyCoachMemory = (auth) => {
  const req = new RequestBuilder(ExternalRESTAPI.MyCoachMemory);
  req.asDELETE().withAuthorization(auth);
  return req.fetch();
};

export const listMyCoachMemoryItems = (auth) => {
  // Default method is GET — no asGET() to call.
  const req = new RequestBuilder(ExternalRESTAPI.MyCoachMemoryItems);
  req.withAuthorization(auth);
  return req.fetch().then(toJSON);
};

export const deleteMyCoachMemoryItem = (auth, memoryId) => {
  const url = `${ExternalRESTAPI.MyCoachMemoryItems}/${encodeURIComponent(memoryId)}`;
  const req = new RequestBuilder(url);
  req.asDELETE().withAuthorization(auth);
  return req.fetch();
};

// Triggers a JSON download of the user's full memory bank. Bypasses
// RequestBuilder.fetch() because we want the raw Response (for blob)
// rather than an auto-parsed body.
export const exportMyCoachMemory = (auth) => {
  const headers = new Headers();
  if (auth?.jwtToken) headers.set("Authorization", `Bearer ${auth.jwtToken}`);
  return fetch(ExternalRESTAPI.MyCoachMemoryExport, { headers });
};

// Drawer-friendly snapshot: structured reflect output + user-set
// preferences in one call.
export const getMyCoachMemoryProfile = (auth) => {
  const req = new RequestBuilder(ExternalRESTAPI.MyCoachMemoryProfile);
  req.withAuthorization(auth);
  return req.fetch().then(toJSON);
};

export const listMyCoachMemoryPreferences = (auth) => {
  const req = new RequestBuilder(ExternalRESTAPI.MyCoachMemoryPreferences);
  req.withAuthorization(auth);
  return req.fetch().then(toJSON);
};

export const addMyCoachMemoryPreference = (auth, text) => {
  const req = new RequestBuilder(ExternalRESTAPI.MyCoachMemoryPreferences);
  req.asPOST(JSON.stringify({ text })).withJSONContentType().withAuthorization(auth);
  return req.fetch().then(toJSON);
};

export const deleteMyCoachMemoryPreference = (auth, prefId) => {
  const url = `${ExternalRESTAPI.MyCoachMemoryPreferences}/${encodeURIComponent(prefId)}`;
  const req = new RequestBuilder(url);
  req.asDELETE().withAuthorization(auth);
  return req.fetch();
};
